import { render, staticRenderFns } from "./JurisdictionCreate.vue?vue&type=template&id=d2f2a1e6&scoped=true&"
import script from "./JurisdictionCreate.vue?vue&type=script&lang=js&"
export * from "./JurisdictionCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2f2a1e6",
  null
  
)

export default component.exports